module.exports = __webpack_public_path__ + "img/contract.edd7006b.png";